import { Slider, Row, Col, Radio } from 'antd';
import React, { useState, useEffect } from 'react';

const LevelofIntefration = ({
  answerValue: value,
  index,
  options,
  changeAnswerValue,
  ...rest
}) => {
  const [selectedTag, setSelectedTag] = useState(index[0]);
  const [sliderV, setSliderV] = useState();

  const handleSliderV = (v) => {
    let sliderV;
    switch (v) {
      case '3':
      case '4':
        sliderV = 3;
        break;
      case '1':
      case '2':
        // case '5':
        sliderV = 7;
        break;
      default:
        sliderV = 3;
    }
    return sliderV;
  };

  useEffect(() => {
    const sliderV = handleSliderV(index[0]);

    setSliderV(sliderV);
    setSelectedTag(index[0]);
  }, [index]);
  const handleChange = (e) => {
    const v = e.target.value;
    const sliderV = handleSliderV(v);
    changeAnswerValue(v);
    setSliderV(sliderV);
    setSelectedTag(v);
  };
  const getLabel = (tagsData) => (
    <Row gutter={[20, 16]}>
      <Radio.Group value={selectedTag} onChange={handleChange}>
        {tagsData.map((tag, idx) => (
          <Col span={24} key={idx}>
            <Radio.Button
              value={tag.index}
              key={tag.index}
              className="level-of-integration-radio"
            >
              {tag.text}
            </Radio.Button>
          </Col>
        ))}
      </Radio.Group>
    </Row>
  );
  const group1 = ['3', '4'].map((item, idx) => ({
    text: options[item - 1].text,
    index: item,
  }));

  const group2 = ['1', '2'].map((item, idx) => ({
    text: options[item - 1].text,
    index: item,
  }));

  const marks = {
    7: {
      style: {
        color: 'rgba(255, 255, 255, 0.45) ',
        width: '13.438rem',
      },
      label: getLabel(group2),
    },
    3: {
      style: {
        // width: '13.438rem',
        color: 'rgba(255, 255, 255, 0.45) ',
      },
      label: getLabel(group1),
    },
  };
  // const handleOnchange = () => {};
  return (
    <>
      <div className="level-of-integration-text">
        <div>Less Complex</div>
        <div>More Complex</div>
      </div>
      <Slider
        style={{ height: '9.688rem' }}
        value={sliderV}
        marks={marks}
        // onChange={handleOnchange}
        // disabled={true}
        dots={true}
        min={1}
        max={9}
        step={null}
        tooltipVisible={false}
        included={false}
        className="level-of-integration-slider"
      />
    </>
  );
};
export default LevelofIntefration;
